import {FETCH_DIGITAL_QURAN_CONTENT} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_DIGITAL_QURAN_CONTENT:
            return action.payload;
        default:
            return state;
    }
};